// Hyperliquid liquidation & resting-stop price profiles (oems #261). Deliberately kept as a
// separate kind union from VisibleRangeProfileKind — these are a structurally different data
// pipeline (live AnalyticsStream, not a one-shot visible-range HTTP request) even though they
// share the same bucket-encoding/rendering conventions.
export type LevelProfileKind = 'liquidationLevels' | 'stopLevels'

export const LEVEL_PROFILE_MEASURE_INPUT_ID = 'measure'

export const LEVEL_PROFILE_STUDIES = {
  liquidationLevels: {
    name: 'OrderX Liquidation Levels',
    shortDescription: 'Liquidation Levels',
  },
  stopLevels: {
    name: 'OrderX Stop Levels',
    shortDescription: 'Stop Levels',
  },
} as const satisfies Record<LevelProfileKind, { name: string; shortDescription: string }>

export function getLevelProfileKindByStudyName(studyName: string): LevelProfileKind | null {
  const entry = (
    Object.entries(LEVEL_PROFILE_STUDIES) as Array<
      [LevelProfileKind, (typeof LEVEL_PROFILE_STUDIES)[LevelProfileKind]]
    >
  ).find(([, definition]) => definition.name === studyName)
  return entry ? entry[0] : null
}
